import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';

export const fetchActivityDetailsRequest = () => ({
  type: actionTypes.FETCH_ACTIVITY_DETAILS_REQUEST
});
export const fetchActivityDetailsFailure = message => ({
  type: actionTypes.FETCH_ACTIVITY_DETAILS_FAILURE,
  message
});
export const fetchActivityDetailsSuccess = details => ({
  type: actionTypes.FETCH_ACTIVITY_DETAILS_SUCCESS,
  details
});

export function fetchActivityDetails(
  activityId,
  activityStationId
) {
  return () => {
    // Params to request bids and preferences.
    const activityDetailsRequestUrl = 'activities/pairing_details';
    // Format StartDate, EndDate, etc.
    const data = {
      activityId,
      activityStationId,
    };
    // Request
    return apiCall(activityDetailsRequestUrl, 'post', data);
  };
}
